import ConfirmationCheckbox from "./ConfirmationCheckbox";
import ConfirmationModal from "./ConfirmationModal";

ConfirmationModal.Checkbox = ConfirmationCheckbox;
export { ConfirmationModal };

export { default } from "./ConfirmationModalWithRedux";
